'use strict';

var Sugar = require('sugar-core');

Sugar.Array.defineInstance({

  'from': function(arr, num) {
    return arr.slice(num);
  }

});

module.exports = Sugar.Array.from;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/from.js
// module id = 379
// module chunks = 0